import getCurrentUrl from "./getCurrentUrl";
import getCurrentSearchParams from "./getCurrentSearchParams";
import replaceUrl from "./replaceUrl";
import getPathSegments from "../../getPathSegments";
import { useState } from "react";

export const useUrlState = () => {
  const setSearchParams = params => {
    const url = getCurrentUrl();
    Object.entries(params).forEach(([key, value]) => {
      if (value === null) {
        url.searchParams.delete(key);

        return;
      }
      url.searchParams.set(key, value);
    });
    replaceUrl(url.href);
    setState(getStateValue());
  };

  const getStateValue = () => {
    const url = getCurrentUrl();
    const pathSegments = getPathSegments(url);
    const [appRootPathSegment, ...subPathSegments] = pathSegments;
    const searchParams = getCurrentSearchParams();

    return {
      appRootPathSegment,
      subPathSegments,
      searchParams,
      setSearchParams
    };
  };

  const [state, setState] = useState(getStateValue());

  return state;
};
